import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';

interface LoginPromptProps {
  title?: string;
  message?: string;
  redirectPath?: string;
}

export const LoginPrompt: React.FC<LoginPromptProps> = ({
  title = 'Sign in to continue',
  message = 'Create an account or sign in to complete your order, chat with support, or book an appointment.',
  redirectPath,
}) => {
  const navigate = useNavigate();
  const redirect = redirectPath || window.location.pathname + window.location.search;
  const loginUrl = `/login?redirect=${encodeURIComponent(redirect)}`;
  const signupUrl = `/signup?redirect=${encodeURIComponent(redirect)}`;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        textAlign: 'center',
        borderRadius: 2,
        border: '1px solid #e8eaed',
        maxWidth: 480,
        mx: 'auto',
      }}
    >
      <LockOutlinedIcon sx={{ fontSize: 48, color: '#606060', mb: 2 }} />
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {message}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Button
          variant="contained"
          onClick={() => navigate(loginUrl)}
          sx={{ bgcolor: '#FFD814', color: '#0f0f0f', '&:hover': { bgcolor: '#F7CA00' } }}
        >
          Sign in
        </Button>
        <Button variant="outlined" onClick={() => navigate(signupUrl)}>
          Create account
        </Button>
      </Box>
    </Paper>
  );
};
